import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import useScrollToTop from "../../blocks/logic/usScrollToTop";
import SEO from "../../components/SEO";
import ShopifyBuyButton from "../../components/ShopifyBuyButton";
import { Container, Section } from "../../components/ui";

const ProductSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const ImageContainer = styled.div`
  position: sticky;
  top: 100px;
  
  @media (max-width: 968px) {
    position: static;
  }
`;

const MainImage = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1);
`;

const ProductInfo = styled.div``;

const Breadcrumb = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1rem;
  
  a {
    color: #6b7280;
    &:hover { color: #0f0f0f; }
  }
`;

const ProductTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const PriceTag = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: #eab308;
  margin-bottom: 1.5rem;
`;

const Description = styled.p`
  color: #6b7280;
  font-size: 1.125rem;
  line-height: 1.75;
  margin-bottom: 2rem;
`;

const BuySection = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
`;

const Note = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 1rem;
`;

const GenericProduct = ({ name, price, image, description, productId, category = "Apparel" }) => {
  useScrollToTop();

  return (
    <>
      <SEO
        title={name}
        description={description}
        url={`https://thenewcalendar.com/shop`}
        image={image}
        type="product"
      />

      <Section>
        <Container>
          <ProductSection>
            <ImageContainer>
              <MainImage $src={image} />
            </ImageContainer>

            <ProductInfo>
              <Breadcrumb>
                <Link to="/shop">Shop</Link> / {category}
              </Breadcrumb>

              <ProductTitle>{name}</ProductTitle>
              <PriceTag>${price}</PriceTag>

              <Description>{description}</Description>

              <BuySection>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <ShopifyBuyButton 
                    productId={productId} 
                    buttonText="Add to Cart"
                    destination="cart"
                  />
                  <ShopifyBuyButton 
                    productId={productId} 
                    buttonText="Buy Now"
                    destination="checkout"
                    showOptions={false}
                  />
                </div>
                <Note>
                  Size and color options available at checkout. Fulfilled by Printful.
                </Note>
              </BuySection>
            </ProductInfo>
          </ProductSection>
        </Container>
      </Section>
    </>
  );
};

export default GenericProduct;
